<script lang="ts">
import { type PropType, defineComponent } from 'vue'

import type { HeaderBanner } from './HeaderBannerBaseCard.vue'
import HeaderBannerBaseCard from './HeaderBannerBaseCard.vue'

/**
 * HeaderBannerUnclippedCard component displays a banner for the "unclipped" variant.
 *
 * Constraints:
 * - background absolutely positioned on the right
 * - left side expanding width
 * - no badge
 * - Trustpilot shown (when `true`) on mobile only
 */
export default defineComponent({
  components: {
    HeaderBannerBaseCard,
  },
  props: {
    banner: {
      type: Object as PropType<HeaderBanner>,
      required: true,
      validator(value: HeaderBanner) {
        if (value.variant !== 'unclipped') {
          console.warn(
            `Incorrect variant "${value.variant}" in HeaderBannerUnclippedCard`,
            this
          )
          return false
        }

        if (value.badge_text) {
          console.warn(
            `badge_text cannot contain a value when variant is "${value.variant}" in HeaderBanner`
          )
          return false
        }

        if (value.show_logo) {
          console.warn(
            `show_logo cannot be true when variant is "${value.variant}" in HeaderBanner`
          )
          return false
        }

        return true
      },
    },
  },
})
</script>

<template>
  <HeaderBannerBaseCard :banner="banner" class="header-banner--unclipped" />
</template>

<style lang="scss">
.header-banner.header-banner--unclipped {
  .header-banner__content {
    @apply p-4;
  }

  .header-banner__text {
    @apply text-4xl !important;
  }

  .header-banner__subtext {
    @apply text-2xl leading-none !important;
  }

  .header-banner__trustpilot {
    @apply block @sm/main:hidden;
  }

  .header-banner__image {
    @apply absolute right-0 top-0;

    img {
      @apply h-full;
    }
  }
}
</style>
